import styled from 'styled-components';

export const StyledPatientExternalIdentifierTypeStillValidEventInterceptorContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 24px;
`;

StyledPatientExternalIdentifierTypeStillValidEventInterceptorContent.displayName =
   'StyledPatientExternalIdentifierTypeStillValidEventInterceptorContent';
